export default __webpack_public_path__ + "static/media/icon_radiobutton-active.a41c8d34.svg";